export const QUESTIONS_PER_BLOCK = 50;
